import { urlLabel } from '@/enum/PermissionEnum';
import { AuthLayout } from '@/module/common';
import { useTheme, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const AuthRoute = ({ component: Component, publicComponent, ...rest }) => {
  const theme = useTheme();
  const isMobileSize = !useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Route
      render={(matchProps) => {
        if (publicComponent || !rest.auth.accessToken)
          return isMobileSize &&
            [
              `/${urlLabel.patientLogin}`,
              `/${urlLabel.patientRegister}`,
              `/${urlLabel.patientForgotPassword}`,
            ].includes(rest.path) ? (
            <Component {...matchProps} {...rest} />
          ) : (
            <AuthLayout>
              <Component {...matchProps} {...rest} />
            </AuthLayout>
          );
        // Resume the deep link WrapperPrivateRoute parked here, if any - this
        // is what sends a doctor straight to their file after logging in,
        // instead of dropping them on the portal home page.
        // URLSearchParams already undoes the encodeURIComponent that
        // WrapperPrivateRoute applied; decoding again would turn a %20 inside
        // an S3 key into a real space and corrupt any key containing % or +.
        const redirect =
          new URLSearchParams(matchProps.location.search).get('redirect') || '';
        // Only in-app paths are followed, never an absolute/external URL.
        const isInAppPath =
          redirect.startsWith('/') && !redirect.startsWith('//');

        return <Redirect to={isInAppPath ? redirect : '/'} />;
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    privilege: state.userPermission.privilege,
  };
};

export const WrapperAuthRoute = connect(mapStateToProps)(AuthRoute);
